import { render, staticRenderFns } from "./AboutDialog.vue?vue&type=template&id=60649f38&scoped=true&"
import script from "./AboutDialog.vue?vue&type=script&lang=js&"
export * from "./AboutDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60649f38",
  null
  
)

export default component.exports